import Helper from './Helper';

class ScrollNav {
  constructor(config = {}) {
    const {
      anchorTextSelector,
      breakpoint
    } = config;

    this.scrollNav = document.querySelector('.lc-scrollnav');

    this.containers = document.querySelectorAll(".lc-start__component");
    this.containersHighlights = document.querySelectorAll(".lc-title-svg__container");
    this.anchorTextSelector = anchorTextSelector || '.ns-anchor-container__anchor-text';
    this.breakpoint = breakpoint || 992;
    this.izContent = document.querySelector('.iz-hosting.startpage');
    this.izHighlights = document.querySelector('.iz-hosting[class*="110-highlights"]');
    this.body = document.querySelector("body");
    this.buttonScrollToIndex = -1;

    this.containersArray = Array.prototype.slice.call(this.containers);
    this.currentScreenWidth = window.innerWidth;

    this.desktopOffset = 112;

    if(!!this.izHighlights) {
      this.izContent = this.izHighlights;
      this.containersArray = Array.prototype.slice.call(this.containersHighlights);
    }

    if (!!this.izContent && !this.scrollNav) {
      if (this.containersArray.length > 1) {
        this.generateSideNav();
      }
    } else if(this.scrollNav) {
      this.scrollNav.remove();

      if (this.containersArray.length > 1) {
        this.generateSideNav();
      }
    }
  }

  generateSideNav() {
    // Abort when the expected container is missing (e.g. on pages without IZ content)
    if (!this.izContent) return;

    let html = '';
    let index = 0;
    let nosn = false;
    html += '<div class="lc-scrollnav">';
    html += '<div class="lc-scrollnav__dots">';
    this.containersArray.forEach(item => {
      let title = '';
      if(item.querySelector('.lc-start__anchor')){
        title = item.querySelector('.lc-start__anchor').innerHTML;
      } else {
        if(item.querySelector('.lc-title-svg__anchor')) {
          title = item.querySelector('.lc-title-svg__anchor').innerHTML;
        }
      }

      item.setAttribute('id', 'lc-scroll-anchor__' + index);
      html += '<a class="lc-scrollnav__item" href="#lc-scroll-anchor__' + index + '"><span class="lc-scrollnav__title">' + title + '</span><svg class="svg-scrollnav" width="44" height="45" viewBox="0 0 46 45" fill="none" xmlns="http://www.w3.org/2000/svg"><path class="path_fill" d="M23 43.8421L45 37.2421V7.6L23 1L1 7.6V37.2421L23 43.8421Z" fill="#D72622" stroke="currentColor"/><path d="M23 43.8422V14.2001L1 7.6001" stroke="currentColor"/>white<path d="M23 14.2001L45 7.6001" stroke="currentColor"/></svg></a>';
      index++;
    });
    html += '</div>';
    html += '</div>';

    this.izContent.insertAdjacentHTML('beforeend', html);

    if(!nosn) {
      this.sideNavLinks = document.querySelectorAll('.lc-scrollnav__item');
      this.sideNavLinksArray = Array.prototype.slice.call(this.sideNavLinks);

      this.sideNavDots = document.querySelector('.lc-scrollnav__dots');

      this.setLinkActive(parseInt(this.getIndex(), 10));

      this.bindLinks();
      this.scrollSpy();
    }

    this.addArrowLinks();
  }

  bindLinks() {
    this.sideNavLinksArray.forEach(el => {
      el.addEventListener("click", (e) => {
        e.preventDefault();
        Helper.addClass(this.body, 'stop-scrollspy');
        this.removeLinkActive(parseInt(this.getIndex(), 10));
        this.scrollTo(el.getAttribute("href").replace('#', ''), 40, this.desktopOffset);
      });
    });
  }

  addArrowLinks() {
    let containersCount = this.containersArray.length;
    this.containersArray.forEach((c, index) => {
      if (index + 1 < containersCount) {
        let arrow = c.querySelector(".lc-scrollnav__item");
        // let nextTitlesText = this.containersArray[index+1].querySelector(this.anchorTextSelector) ? this.containersArray[index+1].querySelector(this.anchorTextSelector).innerHTML : '';

        if(arrow){
          arrow.dataset.scrollTo = index+1;

          arrow.addEventListener("click", (e) => {
            e.preventDefault();
            this.scrollTo(this.containersArray[parseInt(arrow.dataset.scrollTo)], 40, this.desktopOffset);
          });
        }
      }
    });
  }

  scrollTo(element, mobileTopOffset, desktopTopOffset) {
    let queryElement = document.querySelector('#' + element);
    window.scroll({
      behavior: 'smooth',
      left: 0,
      top: Helper.getRealOffsetTop(queryElement) - (window.innerWidth < 992 ? mobileTopOffset : desktopTopOffset)
    });
  }

  scrollSpy() {
    let lastIndex = 0;
    let lastScroll = 0;
    const maxIndex = this.sideNavLinksArray.length;
    let index = parseInt(this.getIndex(), 10);

    if(window.location.hash && !isNaN(window.location.hash.substring(1))) {
      index = window.location.hash.substring(1);
    }

    this.setLinkActive(index);

    document.addEventListener('scroll', () => {
      this.containersArray.forEach(item => {
        if(window.scrollY > item.offsetTop - window.innerHeight/2 && window.scrollY < item.offsetTop + item.clientHeight - window.innerHeight/2) {
          let id = item.getAttribute('id').slice(-1);
          this.setLinkActive(id);
        }
      });

      // if ( this.buttonScrollToIndex === -1 ) {
      //   if (window.scrollY > lastScroll) {
      //     //scrolling down
      //     if (index < maxIndex) {
      //       if (!!this.containersArray[index + 1] && this.isTopInViewportInclHeader(this.containersArray[index + 1])) {
      //         index++;
      //       }
      //     }
      //   } else {
      //     //scrolling up
      //     if (index > 0) {
      //       if (!!this.containersArray[index - 1] && this.isBottomInViewport(this.containersArray[index - 1])) {
      //         index--;
      //       }
      //     }
      //   }
      //   lastScroll = window.scrollY;
      //   if (index != lastIndex) {
      //     if (lastIndex !== false) {
      //       this.removeLinkActive(lastIndex);
      //     }
      //     this.setLinkActive(index);
      //     lastIndex = index;
      //   }
      // } else {
      //   if ( this.isInViewportInclHeader(this.containersArray[this.buttonScrollToIndex]) ) {
      //     Helper.removeClass(this.body, 'stop-scrollspy');
      //     this.buttonScrollToIndex = -1;
      //   }
      // }
    });
  }

  setLinkActive(index) {
    this.sideNavLinks.forEach(link => link.classList.remove('active'));
    const link = this.sideNavLinksArray[index];
    if (!link.classList.contains('active')) link.classList.add('active');
  }

  removeLinkActive(index) {
    const link = this.sideNavLinksArray[index];
    if (link.classList.contains('active')) link.classList.remove('active');
  }

  getIndex() {
    let index = 0;

    this.containersArray.forEach(t => {
      if (this.isInViewportInclHeader(t)) {
        index = t.getAttribute('id').slice(-1);
        return index;
      }
    });
    return index;
  }

  isInViewportInclHeader(elem) {
    const bounding = elem.getBoundingClientRect();
    return (
      (bounding.top >= -(window.innerHeight * 0.2) && bounding.top <= 50) &&
      (bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.bottom >= (window.innerHeight * 0.3))
    );
  }

  isTopInViewportInclHeader(elem) {
    if(elem) {
      const bounding = elem.getBoundingClientRect();
      return (
        (bounding.top >= -(window.innerHeight * 0.2) && bounding.top <= window.innerHeight * 0.5)
      );
    }
  }

  isBottomInViewport(elem) {
    const bounding = elem.getBoundingClientRect();
    return (
      (bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) && bounding.bottom >= (window.innerHeight * 0.5))
    );
  }

}

export default ScrollNav;
